import lottie from 'lottie-web';

const globe = document.querySelector('.globe');
if (globe) {
	lottie.loadAnimation({
		container: globe,
		renderer: 'svg',
		loop: true,
		autoplay: true,
		path: '/wp-content/themes/energirike/lottie/energirike.json'
	});
}
